import { Component, Input, OnInit } from '@angular/core';
import { RoadmapSection } from 'src/app/model/shared/roadmap-section';

@Component({
  selector: 'app-new-roadmap-section',
  templateUrl: './new-roadmap-section.component.html',
  styleUrls: ['./new-roadmap-section.component.scss']
})
export class NewRoadmapSectionComponent implements OnInit {
  @Input() roadmapSections: RoadmapSection[] = [];
  expandedHeadings: string[] = [];
  constructor() {}

  ngOnInit(): void {}

  toggleBody(heading: string): void {
    const index = this.expandedHeadings.indexOf(heading);
    if (index !== -1) {
      if (!heading.includes('Closed')) {
        this.expandedHeadings.splice(index, 1);
      }
    } else {
      this.expandedHeadings.push(heading);
    }
  }

  isContentVisible(roadmapYear: any): boolean {
    if (roadmapYear.includes('Closed')) {
      return this.expandedHeadings.includes(roadmapYear.replace(' Closed', ''));
    }
    return !this.expandedHeadings.includes(roadmapYear);
  }
}
